import { BulletList as TiptapBulletList } from '@tiptap/extension-list'

import { BulletListActionButton } from '@/tiptap/extensions/components/ActionButton'

export const BulletList = TiptapBulletList.extend({
  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      button: ({ editor, t }) => ({
        component: BulletListActionButton,
        componentProps: {
          editor,
          t,
        },
      }),
    }
  },
})

export default BulletList